export enum RouteNames {
  MAIN = 'MAIN',
  PRODUCT = 'PRODUCT',
  DASHBOARD = 'DASHBOARD',
  AUTH = 'AUTH',
  RESTORE_PASS = 'RESTORE_PASS',
  OTP = 'OTP',
  NEW_PASS = 'NEW_PASS',
  REGISTER_AGENT = 'REGISTER_AGENT',
  APPLICATION = 'APPLICATION',
  ALL_APP = 'ALL_APP',
  LAST_APP = 'LAST_APP',
  NEW_APP = 'NEW_APP',
  OPEN_APP = 'OPEN_APP',
  OPEN_OFFER = 'OPEN_OFFER',
  ADMIN_LAST = 'ADMIN_LAST',
  ADMIN_ALL = 'ADMIN_ALL',
  ADMIN_APP = 'ADMIN_APP',
  ADMIN_OFFER = 'ADMIN_OFFER',
  ADMIN_AGENTS = 'ADMIN_AGENTS',
  ADMIN_AGENT = 'ADMIN_AGENT',
  FULL_OFFER = 'FULL_OFFER',
  FULL_APP = 'FULL_APP',
  ADMIN_CATALOG = 'ADMIN_CATALOG',
  ADMIN_CATALOG_ITEM = 'ADMIN_CATALOG_ITEM',
  ADMIN_IMPORT_EXCEL = 'ADMIN_IMPORT_EXCEL',
  DRAFTS = 'DRAFTS',
  ADMIN_DRAFTS = 'ADMIN_DRAFTS',
  DRAFT_VIEW = 'DRAFT_VIEW',
  ADMIN_DRAFT_VIEW = 'ADMIN_DRAFT_VIEW',
  USER_PROFILE = 'USER_PROFILE',
  ADMIN_PROFILE = 'ADMIN_PROFILE',
  REFERAL = 'REFERAL',
  ADMIN_REFERAL_VIEW = 'ADMIN_REFERAL_VIEW',
  REFERAL_VIEW = 'REFERAL_VIEW',
  REFERALS = 'REFERALS',
  ADMIN_REFERALS = 'ADMIN_REFERALS',
  ADMIN_LEADS = 'ADMIN_LEADS',
  ADMIN_LEAD_VIEW = 'ADMIN_LEAD_VIEW',
}

export const ROUTE_PATHS: Record<RouteNames, string> = {
  [RouteNames.MAIN]: '/',

  [RouteNames.PRODUCT]: '/product/:product',

  [RouteNames.AUTH]: '/auth',
  [RouteNames.RESTORE_PASS]: '/auth/restore_pass/mail',
  [RouteNames.OTP]: '/auth/restore_pass/otp',
  [RouteNames.NEW_PASS]: '/auth/restore_pass/new',
  [RouteNames.REGISTER_AGENT]: '/auth/registry',

  [RouteNames.DASHBOARD]: '/dashboard',
  [RouteNames.ALL_APP]: '/dashboard/all/:type',
  [RouteNames.LAST_APP]: '/dashboard/last',
  [RouteNames.NEW_APP]: '/dashboard/new/:type',
  [RouteNames.OPEN_APP]: '/dashboard/app/:type/:uid',
  [RouteNames.OPEN_OFFER]: '/dashboard/offer/:type/:uid',

  [RouteNames.ADMIN_LAST]: '/dashboard/admin/last',
  [RouteNames.ADMIN_ALL]: '/dashboard/admin/all/:type',
  [RouteNames.ADMIN_APP]: '/dashboard/admin/app/:type/:uid',
  [RouteNames.ADMIN_OFFER]: '/dashboard/admin/offer/:type/:uid',
  [RouteNames.ADMIN_AGENTS]: '/dashboard/admin/users/:type',
  [RouteNames.ADMIN_AGENT]: '/dashboard/admin/users/:type/:uid',
  [RouteNames.APPLICATION]: '/app',
  [RouteNames.FULL_APP]: '/app/:type/:uid/:oid',
  [RouteNames.FULL_OFFER]: '/app/full/:type/:uid/:oid',
  [RouteNames.ADMIN_CATALOG]: '/dashboard/admin/catalog',
  [RouteNames.ADMIN_CATALOG_ITEM]: '/dashboard/admin/catalog/:uid',
  [RouteNames.ADMIN_IMPORT_EXCEL]: '/dashboard/admin/import-excel',

  [RouteNames.DRAFTS]: '/dashboard/drafts',
  [RouteNames.ADMIN_DRAFTS]: '/dashboard/admin/drafts',
  [RouteNames.DRAFT_VIEW]: '/dashboard/drafts/:type/:uid',
  [RouteNames.ADMIN_DRAFT_VIEW]: '/dashboard/admin/drafts/:type/:uid',

  [RouteNames.REFERAL]: '/referal',
  [RouteNames.REFERALS]: '/dashboard/referals',
  [RouteNames.ADMIN_REFERALS]: '/dashboard/admin/referals',
  [RouteNames.REFERAL_VIEW]: '/dashboard/referals/:uid',
  [RouteNames.ADMIN_REFERAL_VIEW]: '/dashboard/admin/referals/:uid',

  [RouteNames.USER_PROFILE]: '/dashboard/profile',
  [RouteNames.ADMIN_PROFILE]: '/dashboard/admin/profile',

  [RouteNames.ADMIN_LEADS]: '/dashboard/admin/leads',
  [RouteNames.ADMIN_LEAD_VIEW]: '/dashboard/admin/leads/:uid',
};
